import React from "react";
import Form from "../../../components/form";

export default function PlanoAulas({ unidadeId, history }) {
  const fFiltros = {
    // title: "Unidade",
    // form: camposfiltros(),
    submit: {
      label: "Criar plano de aulas",
      action: () => history.push(`/app/unidade/plano-aulas/${unidadeId}`),
    },
    // history,
    // close: true,
  };

  return (
    <div>
      <Form formData={fFiltros} />
    </div>
  );
}
